import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class TrPlayerMediaService {
    constructor(
        @Inject(DOCUMENT) private document,
    ) { }

    /**
     * Cria e retorna um elemento para embed do projeto
     * @param projectId Identificador do projeto
     */
    public createEmbedProjectElement(projectId: string): HTMLIFrameElement {
        const element = document.createElement('iframe');
        element.className = 'tr-player-project';
        element.name = `player-${projectId}`;
        // element.setAttribute('src', `${this.document.location.protocol}//cdn1.raptmedia.com/projects/${projectId}/embed?autoplay=false&escape=${Math.random().toString()}`);
        element.setAttribute('src', `${this.document.location.protocol}//cdn1.raptmedia.com/projects/${projectId}/embed?autoplay=false`);
        return element;
    }

    /**
     * Formata um valor para exibição do tempo no formato mm:ss.
     * @param timeInSeconds tempo em segundos
     */
    public formatTime(timeInSeconds: string) {

        if (timeInSeconds === `-1` || timeInSeconds === `0`) return '0:00';

        const secNum = parseInt(timeInSeconds, 10);
        const hours   = Math.floor(secNum / 3600);
        const minutes = Math.floor((secNum - (hours * 3600)) / 60);
        const seconds = secNum - (hours * 3600) - (minutes * 60);
        let hoursFormated;
        let minutesFormated;
        let secondsFormated;
        hoursFormated = hours   < 10 ? '0' + hours : hours;
        minutesFormated = minutes < 10 ? '0' + minutes : minutes;
        secondsFormated = seconds < 10 ? '0' + seconds : seconds;

        if (!minutesFormated && !secondsFormated) return '0:00';
        return minutesFormated + ':' + secondsFormated;
    }

    /** Gera um novo guid para identificar um player */
    public generatePlayerGuid(): string {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }
}
